/****************************************************
 * Module Name:  cutProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class CutProxy {
  static GetAllCut = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cut",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllCutMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cut/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleCut = (cutId, callback) => {
    let params = {
      id: cutId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/cut",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckCutAvailable = (cut, callback) => {
    let params = {
      cut: cut,
    };

    restAPICall(
      Constants.MANAGER_URL + "/cut/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddCut = (cut, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cut",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(cut),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateCut = (cut, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/cut",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(cut),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
